import React, { createContext, FC, ReactElement, useContext } from 'react';
import { PageAccountStoryblok } from '../../_shared/interfaces/storyblok';

const Context = createContext({} as PageAccountStoryblok);

type Props = {
    blok: PageAccountStoryblok;
    children: ReactElement<any> | ReactElement<any>[];
};

export const PageAccountStoryblokProvider: FC<Props> = ({ children, blok }) => {
    return <Context.Provider value={blok}>{children}</Context.Provider>;
};

export const usePageAccountStoryblok = () => useContext(Context);
